// @ts-nocheck
import {
  CFG,
  DISCORD_INVITE_URL,
} from "./data";

/* ---------------- Vector helpers ---------------- */
export const len = (x, y) => Math.hypot(x, y);
export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export const lerp = (a, b, t) => a + (b - a) * t;
export const rand = (a, b) => a + Math.random() * (b - a);
export const TAU = Math.PI * 2;

// Per-tab id for POST /presence (counts open pages, including main menu without WS).
export function tabPresenceId() {
  try {
    let id = sessionStorage.getItem("wlkTabId");
    if (!id) {
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : "t" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      sessionStorage.setItem("wlkTabId", id);
    }
    return id;
  } catch (e) {
    return "t" + Math.random().toString(36).slice(2, 14);
  }
}

export function leaveTabPresence() {
  const id = tabPresenceId();
  const url = `/presence?leave=1&tab=${encodeURIComponent(id)}`;
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url);
    return;
  }
  fetch(url, { method: "POST", keepalive: true, headers: { "X-Wlk-Tab-Id": id } }).catch(() => {});
}

export function bindTabPresenceUnload() {
  if (window._wlkPresenceUnload) return;
  window._wlkPresenceUnload = true;
  const onLeave = () => leaveTabPresence();
  window.addEventListener("pagehide", onLeave);
  window.addEventListener("beforeunload", onLeave);
}

// Stable per-browser id for unique splash-view reach (survives tab close).
export function visitSessionId() {
  try {
    let id = localStorage.getItem("wlkVisitId");
    if (!id) {
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : "v" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      localStorage.setItem("wlkVisitId", id);
    }
    return id;
  } catch (e) {
    return "v" + Math.random().toString(36).slice(2, 14);
  }
}

export function recordAlphaSplashView() {
  const sid = visitSessionId();
  const body = JSON.stringify({ sid });
  if (navigator.sendBeacon) {
    navigator.sendBeacon("/api/alpha/splash-view", new Blob([body], { type: "application/json" }));
    return;
  }
  fetch("/api/alpha/splash-view", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

export function track(name, params) {
  try { if (window.gtag) window.gtag("event", name, params || {}); } catch (e) {}
}

// Staged platform shrink (mirror of server platformFrac). PvE floors at
// CFG.pveMinFrac (server PvEMinFrac), so the schedule drops any stage below it —
// otherwise the HUD would warn of a final shrink that the server never applies.
export function shrinkSchedule(matchMode) {
  const pve = matchMode === "pve";
  return {
    startDelay: pve ? CFG.pveShrinkStartDelay : CFG.shrinkStartDelay,
    step: CFG.shrinkStep,
    holds: pve ? CFG.shrinkHolds.map(h => h * CFG.pveShrinkHoldMult) : CFG.shrinkHolds,
    stages: pve ? CFG.shrinkStages.filter(s => s >= CFG.pveMinFrac) : CFG.shrinkStages,
  };
}

export function platformFrac(t, matchMode) {
  const sch = shrinkSchedule(matchMode);
  if (t < sch.startDelay) return 1;
  t -= sch.startDelay;
  const stages = sch.stages;
  let prev = 1;
  for (let i = 0; i < stages.length; i++) {
    const target = stages[i];
    if (t < sch.step) return lerp(prev, target, t / sch.step);
    t -= sch.step;
    if (i === stages.length - 1) return target;
    const hold = sch.holds[i];
    if (t < hold) return target;
    t -= hold;
    prev = target;
  }
  return stages[stages.length - 1];
}

// shrinkState reports the HUD phase: "pre" (before first shrink), "shrinking"
// (a transition is in progress), "hold" (steady between shrinks), or "done".
// nextIn = seconds until the next shrink begins (for pre/hold).
export function shrinkState(t, matchMode) {
  const sch = shrinkSchedule(matchMode);
  const stages = sch.stages;
  if (t < sch.startDelay) return { phase: "pre", nextIn: sch.startDelay - t };
  t -= sch.startDelay;
  for (let i = 0; i < stages.length; i++) {
    if (t < sch.step) return { phase: "shrinking", nextIn: 0 };
    t -= sch.step;
    if (i === stages.length - 1) return { phase: "done", nextIn: 0 };
    const hold = sch.holds[i];
    if (t < hold) return { phase: "hold", nextIn: hold - t };
    t -= hold;
  }
  return { phase: "done", nextIn: 0 };
}

/* ---------------- Color helpers ---------------- */
export function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
}
export function shade(hex, f) {
  const c = hexToRgb(hex);
  const m = (v) => Math.round(clamp(v * f, 0, 255));
  return `rgb(${m(c.r)},${m(c.g)},${m(c.b)})`;
}
export function rgba(hex, a) {
  const c = hexToRgb(hex);
  return `rgba(${c.r},${c.g},${c.b},${a})`;
}

/** Set href on static markup: `<a data-discord-invite>`. */
export function wireDiscordInviteLinks(root = document) {
  root.querySelectorAll("[data-discord-invite]").forEach((el) => {
    if (el instanceof HTMLAnchorElement) el.href = DISCORD_INVITE_URL;
  });
}
